export default __webpack_public_path__ + "static/media/Freebooter's Gauntlets of the Second Caste.fc79fa45.jpg";